import { Link } from "react-router-dom";
import type { AppDataState } from "../api/useAppData";
import OwnerTag from "../components/OwnerTag";

function formatGD(n: number) {
  return n > 0 ? `+${n}` : String(n);
}

export default function PlayersPage({ state }: { state: AppDataState }) {
  const { data } = state;
  if (!data) return <p>Loading…</p>;

  const players = [...data.playerSummaries].sort((a, b) => {
    if (b.teamsRemaining !== a.teamsRemaining)
      return b.teamsRemaining - a.teamsRemaining;
    if (b.goalDifference !== a.goalDifference)
      return b.goalDifference - a.goalDifference;
    if (b.goalsFor !== a.goalsFor) return b.goalsFor - a.goalsFor;
    if (b.points !== a.points) return b.points - a.points;
    return a.person.localeCompare(b.person);
  });

  return (
    <>
      <h1>Players</h1>
      <div className="players-list">
        {players.map((p) => (
          <Link
            key={p.person}
            to={`/player/${encodeURIComponent(p.person)}`}
            className="player-summary"
          >
            <h3>
              <OwnerTag owner={p.person} size="lg" />
            </h3>
            <div className="meta">
              {p.teamsRemaining} teams left · {formatGD(p.goalDifference)} GD ·{" "}
              {p.goalsFor} GF · {p.points} pts
            </div>
            <div className="meta">
              {p.teams.map((t) => t.team).join(", ")}
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}
